import React, {Component} from 'react';

class About extends Component {
    render() {
        return (
            <div className={'aboutContainer'}>
                <h1 className={"About-Header"}>about</h1>
                <div className={"About-Wrapper"}>
                    <p  className={"About-Content"}>The Winter Colloquium on the Physics of Quantum Electronics, known as PQE is an annual physics conference that attracts the world's experts in laser physics, quantum physics, and many other areas. January 2023 marks the 53rd winter meeting.</p>

                    <p className={"About-Content"}>
                        PQE is organized by Marlan Scully. Prof. Scully has been in charge of the conference since its inception.
                    </p>

                    <p className={"About-Content"}>
                        PQE is held at Snowbird Ski and Summer Resort. All events take place in the Cliff Lodge at Snowbird. Snowbird is in Little Cottonwood Canyon, in the Wasatch Mountains near Salt Lake City, Utah, in the United States.
                    </p>
                </div>



            </div>
        );
    }
}

export default About;